'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicMessages = require('@gig/magic-messages');

function deviceChange(callback) {
  return window.eventBus.subscribe(magicMessages.BREAKPOINT_DEVICE_UPDATED, callback, {
    replay: true
  });
}

exports.deviceChange = deviceChange;
